import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import dayjs from 'dayjs';
import Label from '@/components/form/Label/Label';
import 'rc-slider/assets/index.css';

require('dayjs/locale/es');
dayjs.locale('es');

const formatDateToWords = (date) => {
  try {
    const parsedDate = dayjs(date);
    return parsedDate.isValid()
      ? parsedDate.format('dddd D [de] MMMM [de] YYYY')
      : 'Por seleccionar';
  } catch {
    return 'Por seleccionar';
  }
};

const formatDateToWordsEnglish = (date) => {
  try {
    const parsedDate = dayjs(date);
    return parsedDate.isValid()
      ? parsedDate.locale('en').format('dddd, MMMM D, YYYY')
      : 'To be selected';
  } catch {
    return 'To be selected';
  }
};

const GuestDataForm = (props) => {
  const { onSubmitFunction, spaceDetail, lenguage } = props;
  const searchFormData = useSelector((state) => state.searchFormData);
  const spaceTypeFormData = searchFormData?.spaceType;
  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');
  const values = {
    startDate: searchFormData?.startDate ? searchFormData?.startDate : tomorrow,
    startTime: searchFormData?.startTime ? searchFormData?.startTime : '09:00',
    endTime: searchFormData?.endTime ? searchFormData?.endTime : '10:00',
    name: '',
    email: '',
    phone: '',
    countryCode: lenguage === 'EN' ? '+1' : '+52',
    guestQuantyty: searchFormData?.guests ? searchFormData?.guests : 1,
  };

  const peopleLabelEn = values.guestQuantyty === 1 ? ' Person' : ' People';
  const peopleLabelEs = values.guestQuantyty === 1 ? ' Personas' : ' Persona';
  const guestLabel =
    lenguage === 'EN' ? values.guestQuantyty + peopleLabelEn : values.guestQuantyty + peopleLabelEs;
  const dateLabel =
    lenguage === 'EN'
      ? formatDateToWordsEnglish(values?.startDate)
      : formatDateToWords(values?.startDate);
  const startTime = lenguage === 'EN' ? values?.startTime + ' hours' : values?.startTime + ' horas';
  const endTime = lenguage === 'EN' ? values?.endTime + ' hours' : values?.endTime + ' horas';

  const imagesArray = () => {
    try {
      const parsed = JSON.parse(spaceDetail?.main_image);
      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceDetail?.main_image].filter(Boolean);
    } catch {
      return [spaceDetail?.main_image].filter(Boolean);
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FlexContainer column className={'gap-20'}>
        <>
          <img src={imagesArray[0]} alt={''} className={'width100 d-hide m-hide'} />
          <FlexContainer className={'justify-between'}>
            <strong>{lenguage === 'EN' ? 'Date: ' : 'Día: '} </strong>
            <label className={'text-16 m-text-14 '}>{dateLabel} </label>
          </FlexContainer>
          <FlexContainer className={'justify-between'}>
            <strong>{lenguage === 'EN' ? 'Start: ' : 'Inicio: '} </strong>
            <label className={'text-16 m-text-14 '}>{startTime} </label>
          </FlexContainer>
          <FlexContainer className={'justify-between'}>
            <strong>{lenguage === 'EN' ? 'End: ' : 'Fin: '} </strong>
            <label className={'text-16 m-text-14 '}>{endTime} </label>
          </FlexContainer>
          <FlexContainer className={'justify-between'}>
            <label className={'text-16 m-text-14 '}>
              <strong>{lenguage === 'EN' ? 'People: ' : 'Personas: '} </strong>
            </label>
            <label className={'text-16 m-text-14 '}>{guestLabel} </label>
          </FlexContainer>
        </>
        <FlexContainer className={'justify-between borderGray100 justify-between padlr10 padtb10'}>
          <label className={'text-16 m-text-14'}>
            <strong>Total</strong>
          </label>
          <label>
            <strong className={'text-20 m-text-18'}>{spaceDetail?.formattedPrice}</strong>
          </label>
        </FlexContainer>
      </FlexContainer>
      <button
        onClick={() => onSubmitFunction(values)}
        className={
          'bgPink1 width100 border-rad8px borderGray050 fontWhite grayShadow16 margtb30 padlr40 padtb20 text-18'
        }
      >
        <strong>{lenguage === 'ES' ? 'Modificar Reservación' : 'Modify Details'} </strong>
      </button>
    </LocalizationProvider>
  );
};

const ShortReservationDetail = (props) => {
  const { className, onClick, spaceDetail } = props;
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const containerClass = className + ' flex-column border-rad16px margt4 margb20';
  return (
    <FlexContainer className={containerClass}>
      <FlexContainer className={'m-flex-column width100 gap-20'}>
        <FlexContainer className={'flex-column width100'}>
          <Label type="width100 text-24 m-text-22 margb10">
            <strong> {lenguage === 'ES' ? 'Datos de tu Reserva' : 'Reservation Overview'}</strong>
          </Label>
          <GuestDataForm onSubmitFunction={onClick} spaceDetail={spaceDetail} lenguage={lenguage} />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ShortReservationDetail;
